import type { NodeItem, Notes } from '@octopus-do/octopus-project-core'
import {
  thunkUpdateNodeNotes,
  thunkUpdateNodeUrl,
} from '@store/migrationActions/thunkActions/thunkNodesActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import {
  InternalSeoActions,
  type SeoActions,
} from '@store/reducers/seo/actions'
import { put, select } from 'redux-saga/effects'

export function* change({ payload }: ReturnType<typeof SeoActions.change>) {
  const { id, form } = payload

  const trimOrUndefined = (val: string) => {
    return val?.trim()
  }

  const seoImage = form.image
    ? { id: form.image.id, value: form.image.value }
    : undefined

  // seoUrl здесь больше нет намеренно (OCT-4991): updateNotes заменяет
  // notes целиком, поэтому поле уходит из данных при первом же сохранении.
  const notes: Notes = {
    seoTitle: trimOrUndefined(form.title),
    seoDescription: trimOrUndefined(form.description),
    seoSlug: trimOrUndefined(form.slug),
    seoH1: trimOrUndefined(form.h1_header),
    note: trimOrUndefined(form.note),
    keywords: trimOrUndefined(form.keywords),
    pageIntent: trimOrUndefined(form.pageIntent),
    seoImage,
  }

  yield put(InternalSeoActions.change(payload.form))
  yield put(thunkUpdateNodeNotes(id, notes))

  // Адрес страницы живёт не в notes, поэтому пишем его отдельно и только
  // когда он действительно изменился — форма присылает change на каждое поле.
  const node: NodeItem = yield select(
    migrationProjectSelector.getProjectNodeById(id)
  )

  const url = trimOrUndefined(form.url) ?? ''

  if (url !== (node.url ?? '')) {
    yield put(thunkUpdateNodeUrl(id, url))
  }
}
